export default "__VITE_ASSET__DIbR1Ejb__"